'use strict';

const React = require('react');
const PropTypes = React.PropTypes;

const ReactModal = require('react-modal');

const config = require('../../config');
const ResumePropTypes = require('../../prop_types/resume');
const YouTube = require('../../../node_modules/react-youtube/dist/YouTube').default;

const Modal = React.createClass({
    propTypes: {
        entry: ResumePropTypes.publications,
        isOpen: PropTypes.bool.isRequired,
        onRequestClose: PropTypes.func.isRequired
    },

    _onReady: function(event) {
        // access to player in all event handlers via event.target
        //event.target.pauseVideo();
    },

    render: function () {
        const parts = this.props.entry.name.split(':');
        const _name = parts[0];
        // const category = parts[1];
        const tools = parts[2];
	var displayItem, links, details;
        const opts = {
                          height: '100%',
                          width: '100%',
                          playerVars: { // https://developers.google.com/youtube/player_parameters
                            autoplay: 1
                      	  }
                        };
        if (_name in config.portfolio.video && config.portfolio.video[_name].hasOwnProperty('id')) {
                displayItem = <YouTube videoId={config.portfolio.video[_name].id} opts={opts} onReady={this._onReady}/>
	} else if (_name == "Cisco WebEx") {
		displayItem = <iframe src="//www.slideshare.net/slideshow/embed_code/key/puqubAzIHxhZ3S" width="500" height="369" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen></iframe>
        } else {
                displayItem = <img className='scale-with-grid' src={config.portfolio.image[_name].modal} alt={_name}/>
        }

        const style = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
            }
        };

	if (typeof this.props.entry.website !== 'string') {
		links = [];
		for(var i=0;i<this.props.entry.website.length;i++) {
			links.push(<li><a href={this.props.entry.website[i]} target='_blank'>{this.props.entry.website[i]}</a></li>);
		}
	} else {
		details = <a href={this.props.entry.website} target='_blank'>Details</a>;
	}

        return (
            <ReactModal className='popup-modal mfp-hide' isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose} style={style}>
		{displayItem}
                <div className='description-box'>
                    <h5>{_name}</h5>
                    <p>{this.props.entry.summary}</p>
		    {typeof links !== 'undefined' ? (<ul>{links}</ul>) : '' }
                    <span className='categories'>
                        <i className='fa fa-tag'></i>
                        {tools}
                    </span>
                </div>
                <div className='link-box'>
		    {details}
                    <a className='popup-modal-dismiss' onClick={this.props.onRequestClose}>Close</a>
                </div>
            </ReactModal>
        );
    }
});

module.exports = Modal;



// WEBPACK FOOTER //
// ./app/components/section/modal.js